import { FetchIPAddress } from '@/stores/map/mapStore';
import { MAP_INITIAL_STATE } from '@/utils/constants';

export const mockIpData: FetchIPAddress = {
  result: 'success',
  data: {
    ipVersion: 4,
    ipAddress: '73.69.204.157',
    latitude: MAP_INITIAL_STATE.mapCenter.geometry.lat,
    longitude: MAP_INITIAL_STATE.mapCenter.geometry.lng,
    countryName: 'United States of America',
    countryCode: 'US',
    timeZone: '-04:00',
    zipCode: '42051',
    cityName: '(Mock) Hickory',
    regionName: 'Kentecky',
    isProxy: false,
    continent: 'Americas',
    continentCode: 'AM',
    currency: {
      code: 'USD',
      name: 'US Dollar',
    },
    language: 'English',
    timeZones: [
      'America/Adak',
      'America/Anchorage',
      'America/Boise',
      'America/Chicago',
      'America/Denver',
      'America/Detroit',
      'America/Indiana/Indianapolis',
      'America/Indiana/Knox',
      'America/Indiana/Marengo',
      'America/Indiana/Petersburg',
      'America/Indiana/Tell_City',
      'America/Indiana/Vevay',
      'America/Indiana/Vincennes',
      'America/Indiana/Winamac',
      'America/Juneau',
      'America/Kentucky/Louisville',
      'America/Kentucky/Monticello',
      'America/Los_Angeles',
      'America/Menominee',
      'America/Metlakatla',
      'America/New_York',
      'America/Nome',
      'America/North_Dakota/Beulah',
      'America/North_Dakota/Center',
      'America/North_Dakota/New_Salem',
      'America/Phoenix',
      'America/Sitka',
      'America/Yakutat',
      'Pacific/Honolulu',
    ],
    tlds: ['.us'],
  },
};
